// extracted by mini-css-extract-plugin
export default {"search__body":"Searh_search__body__vS9ks","search__icon":"Searh_search__icon__eebDe","search__remove":"Searh_search__remove__QG1rV","search__imput":"Searh_search__imput__Udzjg"};